import { render, staticRenderFns } from "./OwnerForm.vue?vue&type=template&id=8082b886&"
import script from "./OwnerForm.vue?vue&type=script&lang=js&"
export * from "./OwnerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports